module.exports = __webpack_public_path__ + "assets/img/组 448@2x.433d934e.png";